export default "__VITE_ASSET__DWLE4yRC__"